import Vue from 'vue'
import LandingAddToCart from './LandingAddToCart.vue'
import vueCustomElement from 'vue-custom-element'

Vue.use(vueCustomElement);

Vue.customElement('landing-add-to-cart', LandingAddToCart, { shadow: false })
